export const HIRE_DATE = 'hire_date';
export const EMPLOYMENT_DATE = 'employment_date';
export const TERMINATION_DATE = 'termination_date';